// @flow
import { createSelector } from 'reselect';
import shallowequal from 'shallowequal';

import { selectPricingInfos } from '@gandi/billing';
import { instances, type InstancePrice } from '@gandi/redux-resource-price';

import type { Dispatch, FullState, GetState } from '../../types';

// --------------------------------------------------------------------- Actions

export const fetchInstancePrices =
  (options: { ... } = {}): ((dispatch: Dispatch, getState: GetState) => any) =>
  (dispatch: Dispatch, getState: GetState) => {
    const pricingInfos = selectPricingInfos(getState());
    return dispatch(
      // $FlowFixMe[cannot-spread-inexact]
      instances.fetchAll({
        ...pricingInfos,
        ...options,
      }),
    );
  };

export const selectSharedFeatures: (
  state: FullState,
) => InstancePrice['features'] = createSelector(
  instances.selectPricesArray,
  instancePrices =>
    instancePrices[0]
      ? instancePrices[0].features.filter(feature =>
          instancePrices.every(
            price =>
              price.features.find(item => shallowequal(item, feature)) !==
              undefined,
          ),
        )
      : [],
);
